import { OpenNewWindow } from '../../_common'

function NotAvailable({ yearRange }) {
  return (
    <>
      <h1 className="cb-margin-bottom-16 cb-font-weight-regular">
        You do not have any exam registrations for the {yearRange} school year
      </h1>
      <p>
        Each year you take AP Exams, you can have your AP score report sent for free to one
        recipient (a college, university, or scholarship organization). Your official score report
        includes the scores from all AP Exams taken this year and any AP Exams you&#39;ve previously
        taken, along with certain demographic information about you and other information you
        provide during testing. Schools use your official score report to determine credit or
        placement, if applicable. Colleges, universities, and scholarship programs that you send
        your score to may also use your information and official score report to contact you with
        information about admissions, educational, financial aid, and scholarship opportunities.
        Since you are not registered to take any AP Exams this year, no free score send is
        available.
      </p>
      <p>
        If you have taken AP Exams in previous years and would like to send score reports to
        colleges, universities, or scholarship programs, you can do so for a fee. Find out more
        about your options for{' '}
        <OpenNewWindow url="https://apscore.collegeboard.org/scores/score-reporting">
          AP score reporting services<span className="sr-only"> (Opens in a new window)</span>
        </OpenNewWindow>
        .
      </p>
    </>
  )
}

export default NotAvailable
